import * as angular from "angular";
let InviteAppType = {
    selector: "vcInviteAppType",
    templateUrl:
        "/angular/components/invite/sections/invite-app-type.component.html",
    bindings: {
        type: "=",
        finishCallback: "&",
    },
    controller: class InviteAppTypeController {
        // * bindings for typescript compiler *
        public type: any;
        public finishCallback: Function;
        // ************************************
        chooseAppType(app: string): void {
            this.type = app;
            this.finishCallback({ stage: "app_type" });
        }
    },
};
angular.module("invite").component(InviteAppType.selector, InviteAppType);
